import {SortingState} from '@tanstack/table-core';

export const DEFAULT_INVITED_MATCHES_SORT = '-invited_at';

export default function invitedMatchesSortParam(sorting: SortingState): string {
  const sort = sorting[0];
  if (!sort) {
    return DEFAULT_INVITED_MATCHES_SORT;
  }

  if (sort.id === 'invitedStatus') {
    return sort.desc ? '-invited_status' : 'invited_status';
  }

  if (sort.id === 'invitedAt') {
    return sort.desc ? '-invited_at' : 'invited_at';
  }

  return DEFAULT_INVITED_MATCHES_SORT;
}
